import Vue from 'vue'
import Vuex from 'vuex'
import { setItem,getItem } from '../utils/utils.js'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
    token: getItem('webtoken'),
    roleId: getItem('roleId'),
    userInfo: getItem('userInfo'),
    loginState: getItem('loginState'),
    personType: getItem('personType'),
    loginPhone: getItem('loginPhone'),
    showLoginTip: false,
    showRegisterTip: false,
    setRegisterTip: false,
    showQx: false,
    showChangeRole: false
  },
  mutations: {
    setChangeRole(state,data){
      state.showChangeRole = data
    },
    setQx(state, data){
      state.showQx = data
    },
    setLoginTip(state, data){
      state.showLoginTip = data
    },
    setRegisterTip(state, data){
      state.showRegisterTip = data
    },
    setLoginContent(state, data){
      state.token = data
      setItem('webtoken',data)
    },
    setUserRole(state, data) {
      state.roleId = data
      setItem('roleId',data)
    },
    setLoginPhone(state, data){
      state.loginPhone = data
      setItem('loginPhone',data)
    },
    setUserInfo(state, data){
      state.userInfo = data
      setItem('userInfo',data)
    },
    setLoginState(state, data){
      state.loginState = data
      setItem('loginState',data)
    },
    setPersonType(state, data) {
      state.personType = data
      setItem('personType',data)
    },
    exitLogin(state){
      state.loginState = false
      state.personType = null
      state.token = null
      state.userInfo = null
      window.localStorage.clear()
    }
  },
  actions: {
  },
  modules: {
  }
})

export default store

